import React from 'react';

import { Lock } from 'react-feather';
import { useIntl } from 'react-intl';

import { Spinner } from 'components';

import messages from '../messages';
import styles from '../States.module.scss';

const NoPermissionScreen = ({ text, renderIcon, refreshing, onRefresh }) => {
  const intl = useIntl();
  const defaultText = intl.formatMessage(messages.noAccessMessage);

  return (
    <div className={styles.wrap}>
      {renderIcon ? renderIcon(40, '#94a3b8') : <Lock className={styles.icon} size={40} />}
      <p className={styles.text}>{text || defaultText}</p>
      {onRefresh && (
        <button type="button" className={styles.retryBtn} onClick={onRefresh} disabled={refreshing}>
          {refreshing ? <Spinner show size="sm" /> : 'Refresh'}
        </button>
      )}
    </div>
  );
};

export default NoPermissionScreen;
